




import { Vue, Component, Prop } from "vue-property-decorator";
import dompurify from "dompurify";

@Component
export default class Sanitized extends Vue {
  @Prop({ default: "span" })
  public tag!: string;

  @Prop({ required: true })
  public text!: string;

  public get sanitized() {
    return dompurify.sanitize(this.text);
  }
}
